import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { setUsePlanner, setResultBoxStates } from 'redux/modules/adsPlanner';
import { getSocialAccounts } from 'redux/modules/organization';
import { LeftNavLayout } from 'containers';
import { EmptyState, PageHeader, Spinner } from 'components';
import Helmet from 'react-helmet';
import AdsPlannerFlyout from '../AdsPlanner/AdsPlannerFlyout';
import { connect } from 'react-redux';
var AdsWrapper = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  var adsPlanner = state.adsPlanner && state.adsPlanner["".concat(orgId)] ? state.adsPlanner["".concat(orgId)] : null;
  return {
    theme: state.theme,
    adsPlanner: adsPlanner,
    organization: state.organization.current,
    loadingAds: state.ads.loadingAds,
    loadingAdsDashboard: state.ads.loadingAdsDashboard,
    adAccount: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId] : null
  };
}, {
  getSocialAccounts: getSocialAccounts,
  setUsePlanner: setUsePlanner,
  setResultBoxStates: setResultBoxStates
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AdsWrapper, _Component);

  var _super = _createSuper(AdsWrapper);

  function AdsWrapper() {
    _classCallCheck(this, AdsWrapper);

    return _super.apply(this, arguments);
  }

  _createClass(AdsWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getSocialAccounts(this.props.organization.id)["catch"](function (err) {
        console.error(err);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var sidebarItems = [{
        link: "/org/".concat(this.props.organization.id, "/ads/dashboard"),
        linkText: 'Ads Dashboard'
      }, {
        link: "/org/".concat(this.props.organization.id, "/ads/planner"),
        linkText: 'Ads Planner'
      }, {
        link: "/org/".concat(this.props.organization.id, "/ads/all-ads"),
        linkText: 'All Ads'
      }, {
        link: "/org/".concat(this.props.organization.id, "/ads/audiences"),
        linkText: 'Audiences'
      }, {
        link: "/org/".concat(this.props.organization.id, "/ads/leadforms"),
        linkText: 'Lead Forms'
      }];
      var appLayoutInnerStyle = {
        display: 'flex',
        flex: '1 1 auto',
        padding: 0,
        overflow: 'auto',
        height: '100%'
      };
      var wrapStyle = {
        flex: '1 1 auto',
        padding: 0
      };
      return /*#__PURE__*/React.createElement(LeftNavLayout, {
        sidebar: !this.props.loadingAds && this.props.adAccount,
        sidebarItems: sidebarItems,
        params: _objectSpread({}, this.props.params),
        wrapStyle: wrapStyle,
        appLayoutInnerStyle: appLayoutInnerStyle,
        flyoutIcons: ['fa fa-cog', 'fa fa-cog']
      }, this.props.loadingAds ? /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 75,
          marginTop: 50
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })) : this.props.adAccount ? this.props.children : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Helmet, {
        title: "Advertising"
      }), /*#__PURE__*/React.createElement("div", {
        className: "container-fluid"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between',
          padding: '0 36px'
        }
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Advertising",
        pageTitleStyle: {
          marginTop: 0
        }
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(EmptyState, {
        buttonLabel: "Connect Ad Account",
        buttonOnClick: function buttonOnClick() {
          browserHistory.push("/org/".concat(_this.props.organization.id, "/settings/social-accounts"));
        },
        text: "Nothing to see here...until you connect your ad account.",
        iconName: "ion-map",
        iconSize: "95px"
      })))));
    }
  }]);

  return AdsWrapper;
}(Component)) || _class);
export { AdsWrapper as default };